import React, { memo } from 'react';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import styles from './Arrows.module.scss';
import Box from '@/components/UI/box/Box';
const Arrows = ({
  datePickerIsInCurrentMonth,
  clickOnPreMonth,
  dateType,
  months,
  monthNameConvertor,
  clickOnNextMonth,
  isLastMonth
}) => {
  const calendarArrowLeftClass = styles['calendar-arrow-left'] + (isLastMonth() ? ` ${styles['left-disabled']}` : '');
  return <Box className={styles['arrow-container']} data-sentry-element="Box" data-sentry-component="Arrows" data-sentry-source-file="Arrows.tsx">
      <Box className={`${styles['calendar-arrow-right']} ${datePickerIsInCurrentMonth ? ` ${styles['right-disabled']}` : ''}`} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
        <Box onClick={() => !datePickerIsInCurrentMonth && clickOnPreMonth()} className={styles['arrow-button']} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
          <Icon type={datePickerIsInCurrentMonth ? 'lowEmphasis' : 'highEmphasis'} name="arrow-right-1" data-sentry-element="Icon" data-sentry-source-file="Arrows.tsx" />
        </Box>
        <Typography component="span" variant="bodyL" className={styles['date-months-names']} data-sentry-element="Typography" data-sentry-source-file="Arrows.tsx">
          {monthNameConvertor(months[0], dateType)} {months[0]?.year}
        </Typography>
      </Box>
      <Box className={calendarArrowLeftClass} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
        <Typography component="span" variant="bodyL" className={`${styles['date-months-names']} ${styles['mr-16']}`} data-sentry-element="Typography" data-sentry-source-file="Arrows.tsx">
          {monthNameConvertor(months[1], dateType)} {months[1].year}
        </Typography>
        <Box onClick={() => !isLastMonth() && clickOnNextMonth()} className={styles['arrow-button']} data-sentry-element="Box" data-sentry-source-file="Arrows.tsx">
          <Icon type={isLastMonth() ? 'lowEmphasis' : 'inherit'} name="arrow-left" data-sentry-element="Icon" data-sentry-source-file="Arrows.tsx" />
        </Box>
      </Box>
    </Box>;
};
export default memo(Arrows);